import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  send,
} from '@/api/shortmessageserv'

export default {
  state: {
    state_ShortMessage_AddObjResult: null,
    state_ShortMessage_GetAllResult: null,
    state_ShortMessage_GetPageResult: null,
    state_ShortMessage_GetDetailResult: null,
    state_ShortMessage_ModifyObjResult: null,
    state_ShortMessage_DeleteObjResult: null,
    state_ShortMessage_SendResult: null,
  },
  mutations: {
    SET_SHORTMESSAGE_ADDOBJ_RESULT: (state, rst) => {
      state.state_ShortMessage_AddObjResult = rst;
    },
    SET_SHORTMESSAGE_GETALL_RESULT: (state, rst) => {
      state.state_ShortMessage_GetAllResult = rst;
    },
    SET_SHORTMESSAGE_GETPAGE_RESULT: (state, rst) => {
      state.state_ShortMessage_GetPageResult = rst;
    },
    SET_SHORTMESSAGE_GETDETAIL_RESULT: (state, rst) => {
      state.state_ShortMessage_GetDetailResult = rst;
    },
    SET_SHORTMESSAGE_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_ShortMessage_ModifyObjResult = rst;
    },
    SET_SHORTMESSAGE_DELETEOBJ_RESULT: (state, rst) => {
      state.state_ShortMessage_DeleteObjResult = rst;
    },
    SET_SHORTMESSAGE_SEND_RESULT: (state, rst) => {
      state.state_ShortMessage_SendResult = rst;
    },
  },
  actions: {
    ShortMessageServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SHORTMESSAGE_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SHORTMESSAGE_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ShortMessageServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SHORTMESSAGE_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SHORTMESSAGE_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ShortMessageServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SHORTMESSAGE_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SHORTMESSAGE_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ShortMessageServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SHORTMESSAGE_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SHORTMESSAGE_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ShortMessageServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SHORTMESSAGE_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SHORTMESSAGE_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ShortMessageServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SHORTMESSAGE_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SHORTMESSAGE_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ShortMessageServ_Send({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        send(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SHORTMESSAGE_SEND_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SHORTMESSAGE_SEND_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_ShortMessage_AddObjResult: state => {
      return state.state_ShortMessage_AddObjResult;
    },
    get_ShortMessage_GetAllResult: state => {
      return state.state_ShortMessage_GetAllResult;
    },
    get_ShortMessage_GetPageResult: state => {
      return state.state_ShortMessage_GetPageResult;
    },
    get_ShortMessage_GetDetailResult: state => {
      return state.state_ShortMessage_GetDetailResult;
    },
    get_ShortMessage_ModifyObjResult: state => {
      return state.state_ShortMessage_ModifyObjResult;
    },
    get_ShortMessage_DeleteObjResult: state => {
      return state.state_ShortMessage_DeleteObjResult;
    },
    get_ShortMessage_SendResult: state => {
      return state.state_ShortMessage_SendResult;
    },
  }
}